.screenshot-container{display:flex;gap:8px}.screenshot-container .screenshot{width:72px;height:76px;border-radius:4px}.timestamp-text{color:#23242699}.add-screenshot mat-icon{overflow:visible;font-size:16px;margin:0 6px 6px 0}.add-screenshot input{display:none}
/*# sourceMappingURL=feedback.css.map */
